export enum NumberType {
    last_total_etf_btc_usd = 'last_total_etf_btc_usd',
    change_total_7D_btc_etf_native = 'change_total_7D_btc_etf_native',
    change_total_7D_eth_etf_native = 'change_total_7D_eth_etf_native',
    last_total_etf_eth_usd = 'last_total_etf_eth_usd',
    change_total_7D_btc_absolute = 'change_total_7D_btc_absolute',
    change_total_7D_eth_absolute = 'change_total_7D_eth_absolute',
    last_total_rwa_tvl_no_stablecoins = 'last_total_rwa_tvl_no_stablecoins',
    last_total_rwa_stablecoins_tvl = 'last_total_rwa_stablecoins_tvl',
    total_rwa_holders = 'total_rwa_holders',
    total_rwa_stablecoins_holders = 'total_rwa_stablecoins_holders',
    change_total_rwa_holders_30_days = 'change_total_rwa_holders_30_days',
    change_total_rwa_tvl_no_stablecoins_30_days = 'change_total_rwa_tvl_no_stablecoins_30_days',
    change_total_rwa_stablecoins_holders_30_days = 'change_total_rwa_stablecoins_holders_30_days',
    change_total_rwa_stablecoins_tvl_30_days = 'change_total_rwa_stablecoins_tvl_30_days',
    total_tvl_money_market_funds = 'total_tvl_money_market_funds',
    total_tvl_money_market_funds_1Y = 'total_tvl_money_market_funds_1Y',
    total_tvl_private_credit_funds = 'total_tvl_private_credit_funds',
    total_tvl_private_credit_funds_1Y = 'total_tvl_private_credit_funds_1Y',
    m2sl_latest = 'm2sl_latest',
    total_tvl_euros_stablecoins = 'total_tvl_euros_stablecoins',
    percentage_stablecoins_vs_m2 = 'percentage_stablecoins_vs_m2',
    total_tvl_non_tokenized_money_market_fund = 'total_tvl_non_tokenized_money_market_fund',
    total_tvl_non_tokenized_money_market_fund_1Y = 'total_tvl_non_tokenized_money_market_fund_1Y',
    total_tvl_non_tokenized_private_credit_fund = 'total_tvl_non_tokenized_private_credit_fund',
    total_tvl_non_tokenized_private_credit_fund_1Y = 'total_tvl_non_tokenized_private_credit_fund_1Y',
    percentage_money_market_tokenized_vs_non_tokenized = 'percentage_money_market_tokenized_vs_non_tokenized',
    percentage_private_credit_tokenized_vs_non_tokenized = 'percentage_private_credit_tokenized_vs_non_tokenized',
    perentage_money_market_tokenized_vs_non_tokenized_1Y = 'perentage_money_market_tokenized_vs_non_tokenized_1Y',
    perentage_private_credit_tokenized_vs_non_tokenized_1Y = 'perentage_private_credit_tokenized_vs_non_tokenized_1Y',
    total_tradefi_assets = 'total_tradefi_assets',
    eth_price = 'eth_price',
    eth_price_change_7d = 'eth_price_change_7d',
    eth_market_cap = 'eth_market_cap',
    eth_defi_tvl = 'eth_defi_tvl',
    eth_defi_tvl_7d_change_pct = 'eth_defi_tvl_7d_change_pct',
    last_total_rwa_ethereum_stablecoins_tvl = 'last_total_rwa_ethereum_stablecoins_tvl',
    change_total_rwa_ethereum_stablecoins_tvl_7d = 'change_total_rwa_ethereum_stablecoins_tvl_7d'
}
